import React from 'react';
import TennisServeAnalyzer from './components/TennisServeAnalyzer';

export default function App() {
  return <TennisServeAnalyzer />;
}